import { ASSETS_URL } from "@commons-monorepo/index";

export enum EAlliance {
  BOLD = "bold",
}

export const ALLIANCES = [
  {
    image: `${ASSETS_URL}/prod/assets/web/alliance/logo/bold.png`,
    allianceName: EAlliance.BOLD,
  },
];
